import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ErrorAlertProps {
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
  className?: string;
}

const ErrorAlert = ({ message, onRetry, onDismiss, className = '' }: ErrorAlertProps) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      className={`flex items-start gap-3 p-4 rounded-2xl bg-red-50 text-red-800 shadow-soft ${className}`}
    >
      <AlertTriangle size={20} className="shrink-0 mt-0.5 text-red-500" />
      <p className="flex-1 text-sm font-medium leading-relaxed">{message}</p>
      <div className="flex items-center gap-2 shrink-0">
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold bg-white border border-red-200 text-red-700 hover:bg-red-100 transition-colors"
          >
            <RefreshCw size={14} />
            {t('Повторить')}
          </button>
        )}
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            className="p-1.5 rounded-lg hover:bg-red-100 transition-colors text-red-600"
            aria-label={t('Закрыть')}
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorAlert;
